import React, { useState } from 'react'
import { Button, Icon, Label, Confirm } from 'semantic-ui-react';
import { BasicModal } from '../../../../Shared';
import "./AsesorItem.scss";
import { DZ } from '../../../../../api';
import { useAuth } from '../../../../../hooks'
import { AsesorView, AsesorDZForm, AsesorDZForm2, AsesorDZForm3, AsesorDzFormTime } from '../AsesorDZForm';
const DZController = new DZ();

export function AsesorDZItem(props) {
  const { DZ, onReload } = props;
  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const date = new Date(DZ.created_at);
  const createdate = date.toLocaleDateString();
  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseModal2 = () => setShowModal2((prevState) => !prevState);
  const onOpenCloseModal3 = () => setShowModal3((prevState) => !prevState);

  const openVerDoc = () => {
    setTitleModal(`Folio de DZ: ${DZ.folio}`);
    onOpenCloseModal();
  }

  const openVerTime = () => {
    setTitleModal(`Folio de DZ: ${DZ.folio}`);
    onOpenCloseModal3();
  }
  
  const openFormDZ = () => {
    setTitleModal(`Folio de Cotización DZ: ${DZ.folio}`);
    onOpenCloseModal2();
  }



  let contentView = <AsesorView onClose={onOpenCloseModal} onReload={onReload} DZ={DZ} />;
  let contentFormTime = <AsesorDzFormTime onClose={onOpenCloseModal3} onReload={onReload} DZ={DZ} />;
  
  let contentForm;
  if(!DZ.sOpe){
     contentForm = <AsesorDZForm onClose={onOpenCloseModal2} onReload={onReload} DZ={DZ} />;
  }
  else if(DZ.sIyD && !DZ.sOpe2){
     contentForm = <AsesorDZForm2 onClose={onOpenCloseModal2} onReload={onReload} DZ={DZ} />;
  }
  else if(DZ.sOpe2 && !DZ.sAse2){
    contentForm = <AsesorDZForm3 onClose={onOpenCloseModal2} onReload={onReload} DZ={DZ} />;
 }

  let getStatusGeneralColor;
  if (DZ.StatusGeneral === 'Pendiente') {
    getStatusGeneralColor = 'orange'
  } else if (DZ.StatusGeneral === 'Cancelado') {
    getStatusGeneralColor = 'red';
  } else if (DZ.StatusGeneral === 'Finalizado') {
    getStatusGeneralColor = 'green'
  }

  
  return (
    <>
      <div className='cotizacion-item'>
         <div className='column'>
          <p className='cotizacion-item__info'>
            <span className='cotizacion-item__info-label'>Folio fórmula:</span>
            <span className='cotizacion-item__info-valor'>{DZ.folio}</span><br />
            <span className='cotizacion-item__info-label'>Fecha deseada:</span>
            <span className='cotizacion-item__info-valor'> {DZ.fechadeseada?.at(-1) || 'No disponible'}</span>
            <span className='cotizacion-item__info-label'>Creado:</span>
            <span className='cotizacion-item__info-valor'>{createdate}</span><br/>
          </p>
        </div>
        <div className='column'>
          <p className='cotizacion-item__info'>
            {DZ.nombreoficial && (
              <>
                <span className='cotizacion-item__info-label'>Nombre oficial del producto:</span>
                <span className='cotizacion-item__info-valor'>{DZ.nombreoficial}</span>
              </>
            )}
            <span className='cotizacion-item__info-label'>Nombre del producto:</span>
            <span className='cotizacion-item__info-valor'>{DZ.nombre}</span>
            <span className='cotizacion-item__info-label'>Activos:</span>
            <span className='cotizacion-item__info-valor'>{DZ.activos}</span>
          </p>
        </div>
            
        <div className='column'>
                    <p className='cotizacion-item__info'>
                      <label className='estatus_gn'>Estatus General: <Label className={`cotizacion-item__info-statusinde`} color={getStatusGeneralColor}>
                        {DZ.StatusGeneral}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Operaciones: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sOpe ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sOpe ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Investigación y Desarrollo: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sIyD ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sIyD ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Confirmacion de alta asesor: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sAse ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sAse ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Operación Final: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sOpe2 ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sOpe2 ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Asesor Confirmacion Final: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sAse2 ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sAse2 ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                      <label className='estatus_gn'>Estatus Operacion codigo Final: <Label className={`cotizacion-item__info-statusinde`} color={DZ.StatusGeneral === "Cancelado" ? "red" : (DZ.sOpe3 ? 'green' : 'orange')}>
                        { DZ.StatusGeneral === "Cancelado" ? "Cancelado" : (DZ.sOpe3 ? 'Finalizado' : 'Pendiente')}
                      </Label></label>
                    </p>
        </div>
        <div style={{ display: 'flex', gap: '0' }}>
            {DZ.StatusGeneral !== 'Cancelado' && (
              ((DZ.sIyD && !DZ.sAse) || (DZ.sOpe2 && !DZ.sAse2)) && (
            <Button icon primary onClick={openFormDZ}>
              <Icon name='edit'/>
            </Button>
              )
              )}
            <Button icon primary onClick={openVerDoc}>
              <Icon name='eye' />
            </Button>
            <Button icon primary onClick={openVerTime}>
            <Icon name='clock' />
            </Button>
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        {contentView}
      </BasicModal>
      <BasicModal show={showModal2} close={onOpenCloseModal2} title={titleModal}>
        {contentForm}
      </BasicModal>
      <BasicModal show={showModal3} close={onOpenCloseModal3} title={titleModal}>
        {contentFormTime}
      </BasicModal>
    </>
  )
}
